import * as DashboardConstants from "../../constants/DashboardConstants";
import {isEnglish} from "../../common/Translator";
import {getFirstNotNullObj} from "../../common/NamaCommon";
import {calcChartTitle} from "../highCharts/HighGaugeDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHTMLDiv(userDashboardChartLine, h, w, widget) {
    let parameters = userDashboardChartLine.parameters;
    let title = calcChartTitle(userDashboardChartLine);
    let htmlArabic = parameters[DashboardConstants.Param_HTMLArabicTemplate];
    let htmlEnglish = parameters[DashboardConstants.Param_HTMLEnglishTemplate];
    let htmlContent;
    if (isEnglish())
        htmlContent = htmlEnglish;
    else
        htmlContent = htmlArabic;
    htmlContent = getFirstNotNullObj(htmlContent, htmlEnglish, htmlArabic);
    widget.append(`<div style="text-align:center">${title}</div>`);
    if (parameters[DashboardConstants.Param_HTMLOpenInIFrame] === "true") {
        let frame = $("<iframe></iframe>")
        frame.prop("srcdoc", htmlContent);
        frame.width(w);
        frame.height(h);
        widget.append(frame);
    } else {
        widget.append(htmlContent);
    }
    widget.width(w);
    widget.height(h);
    return widget;
}